<div class="pa-file-upload">

    <div *ngIf="errorMessages.length > 0" class="pa-file-error">
        <strong *ngIf="errorMessages.length > 1"
                class="pa-file-error-title">{{'FILE_UPLOAD.TITLE_ERROR_MULTIPLE' | translate }}</strong>
        <strong *ngIf="errorMessages.length === 1"
                class="pa-file-error-title">{{'FILE_UPLOAD.TITLE_ERROR_SINGLE' | translate }}</strong>
        <ul class="pa-file-error-list">
            <li *ngFor="let error of errorMessages" class="pa-file-error-item">
                <span class="pa-file-error-item-name">{{error.file.name}}</span>
                <span>{{'FILE_UPLOAD.' + error.message | translate }}</span><br>
                <span *ngIf="error.detail">{{error.detail}}</span>
            </li>
        </ul>
        <a (click)="clearErrors()" href="#">
            <svg class="pa-file-upload-clear-error-icon" focusable="false" viewBox="0 0 352 512"
                 xmlns="http://www.w3.org/2000/svg">
                <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                      fill="currentColor"></path>
            </svg>
        </a>
    </div>

    <label (dragenter)="$event.preventDefault()"
           (dragleave)="dragLeave()"
           (dragover)="dragOver($event)"
           (drop)="filesDroped($event);"
           class="pa-file-upload-area">
        <input #fileInput (change)="filesSelected($event.target.files);" [disabled]="isUploading" accept="image/*"
               class="pa-file-upload-input" multiple type="file">
        <div [ngClass]="{'pa-file-upload-drag-active' : isDragActive, 'pa-file-upload-button-disabled': isUploading}"
             class="pa-file-upload-button">
            <span>+</span>
        </div>
    </label>

    <div *ngIf="previewFiles.length > 0" class="pa-file-upload-list">
        <div *ngFor="let file of previewFiles" class="pa-file-upload-item">
            <div [ngClass]="{'pa-file-upload-item-image-disabled': isUploading}" [style.background-image]="'url('+ file.data +')'"
                 class="pa-file-upload-item-image"></div>
            <div *ngIf="!isUploading" class="pa-file-upload-item-delete-button-overlay"></div>
            <div (click)="deleteFile(file.id); $event.preventDefault()"
                 *ngIf="!isUploading"
                 class="pa-file-upload-item-delete-button-overlay-text">
                <svg class="pa-file-upload-item-delete-button-icon" focusable="false" viewBox="0 0 352 512"
                     xmlns="http://www.w3.org/2000/svg">
                    <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
                          fill="currentColor"></path>
                </svg>
            </div>
        </div>
    </div>

    <button (click)="uploadFiles()" [disabled]="!canUploadFiles()" class="pa-send-button" type="button">
        <svg aria-hidden="true" class="pa-send-button-icon" data-fa-processed="" data-icon="paper-plane"
             data-prefix="fas" role="img" viewBox="0 0 512 512">
            <path d="M476 3.2L12.5 270.6c-18.1 10.4-15.8 35.6 2.2 43.2L121 358.4l287.3-253.2c5.5-4.9 13.3 2.6 8.6 8.3L176 407v80.5c0 23.6 28.5 32.9 42.5 15.8L282 426l124.6 52.2c14.2 6 30.4-2.9 33-18.2l72-432C515 7.8 493.3-6.8 476 3.2z"
                  fill="currentColor"></path>
        </svg>
    </button>
</div>
